import { Helmet } from 'react-helmet-async';
import AuthNewPassword from 'src/sections/auth/AuthNewPassword';
import { translateKey } from 'src/locales/translate';

// ----------------------------------------------------------------------

export default function NewPasswordPage() {
  return (
    <>
      <Helmet>
        <title>{translateKey("hardcoded.zmiana_hasla_vetsi")}</title>
      </Helmet>
      <AuthNewPassword />
    </>
  );
}
